import { useState } from 'react';
import axios from 'axios';
import { apiKey, apiUrl } from '../lib/config';

export const useApiDelete = (url, token = null) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const deleteData = async (payload = {}) => {
    setLoading(true);
    setError(null);

    try {
      const fullUrl = apiUrl + url;
      const headers = {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(apiKey && { 'x-api-key': apiKey }),
        'Content-Type': 'application/json',
      };

      const response = await axios.delete(fullUrl, {
        headers,
        data: payload, // in DELETE, data must be sent explicitly like this
      });

      setResponseData(response.data);
      return { result: response.data, error: null };
    } catch (err) {
      let errorMsg = "Something went wrong";
      const errorResMsg = err?.response?.data?.message;
      const defaultMsg = err?.message;

      if (errorResMsg?.trim()) {
        errorMsg = errorResMsg;
      } else if (defaultMsg?.trim()) {
        errorMsg = defaultMsg;
      }

      setError(errorMsg);
      return { result: null, error: errorMsg };
    } finally {
      setLoading(false);
    }
  };

  return { deleteData, loading, error, responseData };
};
